import { createTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import { isGloboCurrentApp, FontFamilyByCurrentApp, MuiFormLabelColorByCurrentApp, PrimaryMainBackgroundColorByCurrentApp, GradientBackgroundImageByCurrentApp, MuiFormLabelFilledColorByCurrentApp } from '../utils/get-app-env';
import "typeface-roboto"
import "typeface-montserrat"


const handlePaletteUsage = () => {
  return !isGloboCurrentApp() ? {
    primary: {
      main: '#7F7F7F'
    }
  } : {
    primary: {
      main: '#0D3EFB',
      light: '#66B2FF',
      dark: '#0059B2',
      contrastText: '#FFF',
    },
    divider: '#132F4C',
    background: {
      default: '#001E3C',
      paper: '#FFF',
    },
    common: {
      black: '#1D1D1D',
      white: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.45)',
      secondary: 'rgba(51 51 51, 0.9)',
      disabled: 'rgba(255, 255, 255, 0.5)',
    },
    grey: {
      '50': '#F3F6F9',
      '100': '#EAEEF3',
      '200': '#E5E8EC',
      '300': '#D7DCE1',
      '400': '#BFC7CF',
      '500': '#AAB4BE',
      '600': '#7F8E9D',
      '700': '#46505A',
      '800': '#2F3A45',
      '900': '#20262D',
      A100: '#f5f5f5',
      A200: '#eeeeee',
      A400: '#bdbdbd',
      A700: '#616161',
    },
    error: {
      '50': '#FFF0F1',
      '100': '#FFDBDE',
      '200': '#FFBDC2',
      '300': '#FF99A2',
      '400': '#FF7A86',
      '500': '#FF505F',
      '600': '#EB0014',
      '700': '#C70011',
      '800': '#94000D',
      '900': '#570007',
      main: '#EB0014',
      light: '#FF99A2',
      dark: '#C70011',
      contrastText: '#fff',
    },
    success: {
      '50': '#E9FBF0',
      '100': '#C6F6D9',
      '200': '#9AEFBC',
      '300': '#6AE79C',
      '400': '#3EE07F',
      '500': '#21CC66',
      '600': '#1DB45A',
      '700': '#1AA251',
      '800': '#178D46',
      '900': '#0F5C2E',
      main: '#1DB45A',
      light: '#6AE79C',
      dark: '#1AA251',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    warning: {
      '50': '#FFF9EB',
      '100': '#FFF4DB',
      '200': '#FFEDC2',
      '300': '#FFE4A3',
      '400': '#FFD980',
      '500': '#FCC419',
      '600': '#FAB005',
      '700': '#F1A204',
      '800': '#DB9A00',
      '900': '#8F6400',
      main: '#F1A204',
      light: '#FFE4A3',
      dark: '#F1A204',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    info: {
      main: '#29b6f6',
      light: '#4fc3f7',
      dark: '#0288d1',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    action: {
      active: '#a4adb5',
      hover: 'rgba(34, 59, 107, 0.2)',
      hoverOpacity: 0.08,
      selected: 'rgba(150, 150, 150, 0.1)',
      selectedOpacity: 0.16,
      disabled: '#EAEFF2',
      disabledBackground: '#C1C6CA',
      disabledOpacity: 0.38,
      focus: 'rgba(255, 255, 255, 0.12)',
      focusOpacity: 0.12,
      activatedOpacity: 0.24,
    },
  }
}

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    components: {
      [key: string]: {};
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    components?: {
      [key: string]: {};
    };
  }
}

export const Container = styled.div<{ isInLoginPage: any }>`
  ${({ isInLoginPage }) =>
  isInLoginPage && 'background-image: '+(GradientBackgroundImageByCurrentApp())+';'}
`;

export const customTheme = createTheme({
  overrides: {
    MuiButton: {
      root: {
        '&$disabled': {
          color: '#EAEFF2',
          backgroundColor: '#C1C6CA',
        },
      },

      contained: {
        backgroundColor: PrimaryMainBackgroundColorByCurrentApp(),
        color: '#FFFFFF',

        '&:hover': {
          backgroundColor: '#3C2EE3',
        },
        '&:active': {
          backgroundColor: '#223B6B',
        },
      },

      label: {
        fontSize: '1.2rem',
      },
    },

    MuiList: {
      root: {
        width: '190px',
      }
    },

    MuiPaper: {
      rounded: {
        borderRadius: '10px',
      },
    },

    MuiDialogActions: {
      root: {
        padding: '15px',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    MuiTypography: {
      subtitle1: {
        fontSize: '1rem',
        color: '#fff',
      },

      h4: {
        fontSize: '2rem',
        textDecoration: 'none',
      },

      body1: {
        fontWeight: 500,
        color: MuiFormLabelColorByCurrentApp(),
      },
    },

    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderWidth: '1px',
        },
      },

      notchedOutline: {
        borderColor: '#A2A7AC',
      },
    },

    MuiFormLabel: {
      root: {
        color: MuiFormLabelColorByCurrentApp()
      },
      filled: {
        color: MuiFormLabelFilledColorByCurrentApp()
      }
    },

    MuiInputBase: {
      root: {
        color: MuiFormLabelColorByCurrentApp()
      }
      
    },

    MuiIconButton: {
      root: {
        color: MuiFormLabelColorByCurrentApp()
      }
    },  
  },

  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
    unit: 'px',
  },
  direction: 'ltr',
  palette: handlePaletteUsage(),
  shape: {
    borderRadius: 3,
  },
  spacing: 8,
  unstable_strictMode: true,
  typography: {
    h1: {
      fontFamily: FontFamilyByCurrentApp(),
      fontSize: 'clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)',
      fontWeight: 800,
      lineHeight: 1.1142857142857143,
    },
    h2: {
      fontFamily: FontFamilyByCurrentApp(),
      fontSize: 'clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)',
      fontWeight: 800,
      lineHeight: 1.2222222222222223,
      color: '#E5E8EC',
    },
    h3: {
      fontSize: '2.25rem',
      lineHeight: 1.2222222222222223,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
    },
    h4: {
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.5rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
    },
    h6: {
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 500,
      width: '90%',
    },
    button: {
      textTransform: 'initial',
      fontWeight: 400,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontSize: '0.875rem',
      lineHeight: 1.75,
    },
    subtitle1: {
      fontSize: '1.125rem',
      lineHeight: 1.3333333333333333,
      letterSpacing: 0,
      fontWeight: 500,
      fontFamily: FontFamilyByCurrentApp(),
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
    },
    caption: {
      display: 'inline-block',
      fontSize: '0.75rem',
      lineHeight: 1.5,
      letterSpacing: 0,
      fontWeight: 700,
      fontFamily: FontFamilyByCurrentApp(),
    },
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    subtitle2: {
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.57,
    },
    overline: {
      fontFamily: FontFamilyByCurrentApp(),
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 2.66,
      textTransform: 'uppercase',
    },
  },
  props: {
    MuiBadge: {
      overlap: 'rectangle',
    },
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
});
